module.exports = __webpack_public_path__ + "static/media/han-taste-ad3.107e5074.png";